interface DurationParts {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
}

export const calculateDuration = (
  startTime: string,
  endTime: string | undefined,
  currentTime: number
): number => {
  const startDate = new Date(startTime);
  const endDate = endTime ? new Date(endTime) : new Date(currentTime);

  return endDate.getTime() - startDate.getTime();
};

export const convertMillisecondsToParts = (
  milliseconds: number
): DurationParts => {
  const seconds = Math.floor(milliseconds / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);

  return {
    days,
    hours: hours % 24,
    minutes: minutes % 60,
    seconds: seconds % 60,
  };
};

export const formatDurationParts = (parts: DurationParts): string => {
  const formattedParts: string[] = [];

  const hasDays = parts.days > 0;
  const hasHours = parts.hours > 0 || hasDays;
  const hasMinutes = parts.minutes > 0 || hasHours;

  if (hasDays) {
    formattedParts.push(`${parts.days}d`);
  }
  if (hasHours) {
    formattedParts.push(`${parts.hours}h`);
  }
  if (hasMinutes) {
    formattedParts.push(`${parts.minutes}m`);
  }
  formattedParts.push(`${parts.seconds}s`);

  return formattedParts.join(' ');
};

export const formatDuration = (
  startTime: string,
  endTime: string | undefined,
  currentTime: number
): string => {
  const durationInMilliseconds = calculateDuration(
    startTime,
    endTime,
    currentTime
  );

  const isNegativeDuration = durationInMilliseconds < 0;
  if (isNegativeDuration) {
    return '-';
  }

  const isLessThanOneSecond = durationInMilliseconds < 1000;
  if (isLessThanOneSecond) {
    return '<1s';
  }

  const parts = convertMillisecondsToParts(durationInMilliseconds);
  return formatDurationParts(parts);
};
